<template>
  <div class="min-h-screen">
    <NavBar :signed-in="signedIn" :user-name="userName" active-page="" />

    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 class="text-2xl font-bold text-gray-900 mb-6">{{ t('cookies.policy_title') }}</h1>

      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6 space-y-4">
        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('cookies.what_title') }}</h2>
          <p class="text-sm text-gray-600">{{ t('cookies.what_text') }}</p>
        </section>

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('cookies.essential_title') }}</h2>
          <p class="text-sm text-gray-600">{{ t('cookies.essential_text') }}</p>
          <ul class="mt-2 text-sm text-gray-600 list-disc list-inside space-y-1">
            <li>{{ t('cookies.essential_session') }}</li>
            <li>{{ t('cookies.essential_csrf') }}</li>
            <li>{{ t('cookies.essential_consent') }}</li>
          </ul>
        </section>

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('cookies.optional_title') }}</h2>
          <p class="text-sm text-gray-600">{{ t('cookies.optional_text') }}</p>
        </section>

        <section>
          <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ t('cookies.manage_title') }}</h2>
          <p class="text-sm text-gray-600">{{ t('cookies.manage_text') }}</p>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import NavBar from './NavBar.vue'

const props = defineProps({ signedIn: Boolean, userName: String })
const { t } = useI18n()
</script>
